import { formatDate, registerLocaleData } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { AutenticaoService } from 'src/app/auth/autenticacao.service';
import { ModalErroComponent } from 'src/app/components/modal-erro/modal-erro.component';
import { FalhaServico } from 'src/app/models/falha-servico';
import {
  DescriptionBlocks,
  DescriptionTypes,
} from 'src/app/models/finalidades.model';
import { InformacaoCadastro } from 'src/app/models/informacoesCadastrais/info-cadastro';
import { DataOrderRequest } from 'src/app/models/pedido/request/data-order-request';
import { FinalidadeRequest } from 'src/app/models/pedido/request/finalidade-request';
import {
  RelatorioAnaliticoModel,
  RelatorioAnaliticoScrModel,
} from 'src/app/models/relatorio-analitico.model';
import { RelatorioAnaliticoService } from 'src/app/pages/relatorio-analitico/relatorio-analitico.service';
import { environment } from 'src/environments/environment';

registerLocaleData(localePtBr);

export enum AlertType {
  SUCCESS,
  ERROR,
  INFO,
  NO_INFO_FOUND,
}

@Component({
  selector: 'app-relatorio-analitico',
  templateUrl: './relatorio-analitico.component.html',
  styleUrls: ['./relatorio-analitico.component.scss'],
})
export class RelatorioAnaliticoComponent implements OnInit {
  @ViewChild('modalErro') modalErro: ModalErroComponent;
  abrirModalErroPdf: boolean = false;
  urlPdf: string;
  form: FormGroup;
  submitting: boolean = false;
  protocolo: number = 0;
  numpedido: string = '';
  datacriacaoprotocolo: Date;
  datainicioinformacao: Date;
  datafiminformacao: Date;
  status: string = '';
  menssagemErro: string = '';
  menssagemAtencao: string = '';
  pedido: DataOrderRequest;
  informacaoCadastro: InformacaoCadastro;
  controlessolicitarRelAnalitico: Boolean = false;

  listaFinalidadesDadosCadastrais: FinalidadeRequest;
  listaFinalidadesDadosLocalizacao: FinalidadeRequest;
  listaFinalidadesDadosConsultasCPF: FinalidadeRequest;
  listaFinalidadesDadosParticipacaoSocietaria: FinalidadeRequest;
  listaFinalidadesCertificado: FinalidadeRequest;

  public larguraEhSuperiorMin: boolean;
  public listaServicoFalha: Array<string>;
  public falha: boolean;
  public falhaServico: FalhaServico;
  public dadosCadastrais: RelatorioAnaliticoModel[];
  public dadosLocalizacao: RelatorioAnaliticoModel[];
  public dadosParticipacaoSoc: RelatorioAnaliticoModel[];
  public dadosOutrosCadastrais: RelatorioAnaliticoModel[];
  public dadosConsultaCredito: RelatorioAnaliticoModel[];
  public dadosConsultaLockUnlock: RelatorioAnaliticoModel[];
  public dadosConsultaCertificado: RelatorioAnaliticoModel[];
  public dadosDocumentosExtraviados: RelatorioAnaliticoModel[];
  public dadosScr: RelatorioAnaliticoScrModel[];

  public MostrarDadosCadastrais: boolean;
  public MostrarLocalizacao: boolean;
  public MostrarPartiSocietaria: boolean;
  public MostrarOutrosCadastrais: boolean;
  public MostrarConsultaCredito: boolean;
  public MostrarConsultaLockUnlock: Boolean;
  public MostrarConsultaCertificado: Boolean;
  public MostrarDocumentosExtraviados: Boolean;
  public MostrarScr: Boolean;

  public disclaimerdadosCadastrais: boolean;
  public disclaimerdadosLocalizacao: boolean;
  public disclaimerdadosParticipacaoSoc: boolean;
  public disclaimerdadosOutrosCadastrais: boolean;
  public disclaimerdadosConsultaCredito: boolean;
  public disclaimerdadosConsultaLockUnlock: boolean;
  public disclaimerdadosConsultaCertificado: boolean;
  public disclaimerdadosConsultaScr: boolean;

  public disclaimerMarketing: boolean;
  public disclaimerCredito: boolean;
  public disclaimerFraude: boolean;
  public disclaimerDataQuality: boolean;
  public disclaimerCertificado: boolean;
  public disclaimerScr: boolean;

  successAlertActive: boolean = false;
  errorAlertActive: boolean = false;
  infoAlertActive: boolean = false;
  noInfoFoundAlertActive: boolean = false;
  public ativo = true;
  public executar = false;

  constructor(
    private cookieService: CookieService,
    public relatorioAnaliticoService: RelatorioAnaliticoService,
    private router: Router,
    private autenticaoService: AutenticaoService
  ) {
    this.dadosCadastrais = new Array<RelatorioAnaliticoModel>();
    this.dadosLocalizacao = new Array<RelatorioAnaliticoModel>();
    this.dadosParticipacaoSoc = new Array<RelatorioAnaliticoModel>();
    this.dadosOutrosCadastrais = new Array<RelatorioAnaliticoModel>();
    this.dadosConsultaCredito = new Array<RelatorioAnaliticoModel>();
    this.dadosConsultaLockUnlock = new Array<RelatorioAnaliticoModel>();
    this.dadosConsultaCertificado = new Array<RelatorioAnaliticoModel>();
    this.dadosDocumentosExtraviados = new Array<RelatorioAnaliticoModel>();
    this.dadosScr = new Array<RelatorioAnaliticoModel>();

    this.checarAcessoViaRedirect();
  }

  checarAcessoViaRedirect() {
    sessionStorage.setItem('pathRedirect', '/relatorio-analitico');
    if (sessionStorage.getItem('accessTokenJWT') == null) {
      if (!this.cookieService.get('Valgrind-AU')) {
        window.location.href =
          environment.urlPortal +
          '/entrar?redirectUrl=' +
          environment.urlRedirecionamentoRelatorioAnalitico;
      }
      this.autenticaoService.accessTokenExiste.subscribe((res) => {
        if (res) {
          this.executar = res;
        }
      });
    } else {
      this.executar = true;
    }
  }

  ngOnInit(): void {
    this.checarAcessoViaRedirect();
    this.disclaimerdadosCadastrais = false;
    this.disclaimerdadosLocalizacao = false;
    this.disclaimerdadosParticipacaoSoc = false;
    this.disclaimerdadosOutrosCadastrais = false;
    this.disclaimerdadosConsultaCredito = false;
    this.disclaimerdadosConsultaLockUnlock = false;
    this.disclaimerdadosConsultaCertificado = false;
    this.disclaimerdadosConsultaScr = false;

    this.disclaimerMarketing = false;
    this.disclaimerCredito = false;
    this.disclaimerFraude = false;
    this.disclaimerDataQuality = false;
    this.disclaimerCertificado = false;
    this.disclaimerScr = false;

    this.listaServicoFalha = new Array();
    this.errorAlertActive = false;
    this.larguraEhSuperiorMin = this.checarLarguraTela();

    if (this.executar) {
      this.verificarStatusPedido();
    }
  }

  public verificarStatusPedido() {
    this.ativo = true;
    this.controlessolicitarRelAnalitico = false;
    // Paleativo para fluxo de redirecionamento de certificado 1/2
    // Obs: Fluxo 2/2 AuthenticationComponent
    this.relatorioAnaliticoService
      .retrievePedido()
      .subscribe(
        (res) => {
          if (res != null && res.orders != null) {
            res.orders = res.orders.sort((val1: any, val2: any) => {
              return Date.parse(val2.dtCreate) - Date.parse(val1.dtCreate);
            });

            for (var i = 0; i < res.orders.length; i++) {
              this.datacriacaoprotocolo = new Date(
                res.orders[i].dtCreate.toString()
              );
              this.protocolo = res.orders[i].protocol;
              this.status = res.orders[i].status.toLocaleUpperCase();
              this.numpedido = res.orders[i].orderId;
              this.datainicioinformacao = res.orders[i].dtStart;
              this.datafiminformacao = res.orders[i].dtEnd;
              if (this.status === 'FINALIZADO') {
                this.controlessolicitarRelAnalitico = true;
                this.gerarRelatorio();
                break;
              } else {
                this.menssagemAtencao = ''.concat(
                  'Por favor, aguarde a conclusão da solicitação ',
                  this.protocolo.toString(),
                  ' criado em ',
                  formatDate(
                    this.datacriacaoprotocolo,
                    'fullDate',
                    'pt'
                  ).toString(),
                  ' que está em processamento.'
                );
                this.showAlertMessage(AlertType.INFO);
              }
            }
          }
          this.ativo = false;
        },
        (error) => {
          if (
            (error.error[0] &&
              error.error[0].message
                .toLocaleUpperCase()
                .indexOf('PEDIDO NAO ENCONTRADO') >= 0) ||
            (error.message &&
              error.message
                .toString()
                .toLocaleUpperCase()
                .indexOf('404 NOT FOUND') >= 0)
          ) {
            this.showAlertMessage(AlertType.NO_INFO_FOUND);
            this.controlessolicitarRelAnalitico = false;
            console.log('error - ' + error.message);
          } else {
            this.menssagemAtencao = 'Erro';
            this.menssagemErro =
              'Não foi possível processar sua requisição, por favor tente mais tarde!';
            this.showAlertMessage(AlertType.ERROR);
            this.controlessolicitarRelAnalitico = false;
          }
          this.ativo = false;
        }
      )
      .add(() => {
        if (this.protocolo === 0 && this.status === '') {
          this.showAlertMessage(AlertType.NO_INFO_FOUND);
          this.controlessolicitarRelAnalitico = false;
        }
      });
  }

  public validateToken() {
    // Paleativo para fluxo de redirecionamento de certificado 1/2
    // Obs: Fluxo 2/2 AuthenticationComponent
    if (sessionStorage.getItem('accessTokenJWT')) {
      const decoded = jwt_decode(sessionStorage.getItem('accessTokenJWT'));
      if (
        !decoded.authorities
          .toString()
          .includes('ROLE_PERSON_VALIDATED', 'ROLE_AUTH-STRONG')
      ) {
        this.router.navigate(['/prova-de-vida']);
      }
    }
  }

  public showAlertMessage(type: AlertType) {
    this.successAlertActive = false;
    this.errorAlertActive = false;
    this.infoAlertActive = false;
    this.noInfoFoundAlertActive = false;

    switch (type) {
      case AlertType.SUCCESS: {
        this.successAlertActive = true;
        break;
      }
      case AlertType.ERROR: {
        this.errorAlertActive = true;
        break;
      }
      case AlertType.INFO: {
        this.infoAlertActive = true;
        break;
      }
      case AlertType.NO_INFO_FOUND: {
        this.noInfoFoundAlertActive = true;
        break;
      }
    }
  }

  public createBlocoDados(
    atributo?: string,
    informacao?: string,
    finalidade?: string,
    origem?: string,
    disclaimer: boolean = false
  ) {
    const naoInformado = 'Não Informado';
    const bloco = new RelatorioAnaliticoModel();
    bloco.atributo = atributo;
    bloco.informacao = informacao;
    bloco.finalidade = informacao !== naoInformado ? finalidade : null;
    bloco.origem = informacao !== naoInformado ? origem : null;
    bloco.disclaimer = disclaimer === undefined ? false : disclaimer;

    return bloco;
  }

  public createBlocoPassagem(
    empresa?: string,
    cnpj?: string,
    finalidade?: string,
    origem?: string,
    dtSearch?: Date,
    numSearches?: number
  ) {
    const bloco = new RelatorioAnaliticoModel();
    bloco.empresa = empresa;
    bloco.cnpj = cnpj;
    bloco.dtSearch = dtSearch;
    bloco.numSearches = numSearches;
    bloco.finalidade = finalidade;
    bloco.origem = origem;
    return bloco;
  }

  public createBlocoScr(
    atributo?: string,
    financialInstitution?: string,
    contract?: string,
    modality?: string,
    referenceDate?: string,
    informacao?: string,
    finalidade?: string,
    origem?: string,
    disclaimer: boolean = false
  ) {
    const naoInformado = 'Não Informado';
    const bloco = new RelatorioAnaliticoScrModel();
    bloco.atributo = atributo;
    bloco.origem = informacao !== naoInformado ? origem : null;
    bloco.financialInstitution = financialInstitution;
    bloco.contract = contract;
    bloco.modality = this.prepareModality(modality);
    bloco.referenceDate = referenceDate;
    bloco.informacao = informacao;
    bloco.finalidade = finalidade;
    bloco.disclaimer = disclaimer === undefined ? false : disclaimer;

    return bloco;
  }

  public sortByAtributo(
    collection: any,
    attribute: string,
    direction?: string
  ): any {
    if (collection && collection.length > 0) {
      return collection.sort((a, b) => {
        if (a[attribute] && b[attribute]) {
          if (direction === 'DESC') {
            return a[attribute].toUpperCase() < b[attribute].toUpperCase()
              ? 1
              : a[attribute].toUpperCase() === b[attribute].toUpperCase()
              ? 0
              : -1;
          }
          return a[attribute].toUpperCase() > b[attribute].toUpperCase()
            ? 1
            : a[attribute].toUpperCase() === b[attribute].toUpperCase()
            ? 0
            : -1;
        }
      });
    } else {
      return collection;
    }
  }

  public gerarRelatorio() {
    this.MostrarDadosCadastrais = false;
    this.MostrarLocalizacao = false;
    this.MostrarPartiSocietaria = false;
    this.MostrarOutrosCadastrais = false;
    this.MostrarConsultaCredito = false;
    this.MostrarConsultaLockUnlock = false;
    this.MostrarConsultaCertificado = false;
    this.MostrarDocumentosExtraviados = false;
    this.MostrarScr = false;
    if (this.controlessolicitarRelAnalitico && this.numpedido.length > 0) {
      this.relatorioAnaliticoService
        .consultarInformacoesRelatorio(this.numpedido)
        .subscribe(
          (conteudo) => {
            if (
              conteudo != null &&
              conteudo.blocks != null &&
              conteudo.blocks.length > 0
            ) {
              conteudo.blocks.forEach((blocos) => {
                switch (blocos.description.toLocaleUpperCase()) {
                  case DescriptionBlocks.DADOSCADASTRAIS:
                  case DescriptionBlocks.IDENTIFICACAO: {
                    this.MostrarDadosCadastrais = true;
                    blocos.attributes.forEach((atributo) => {
                      atributo.purposes.forEach((finalidade) => {
                        this.tratarAtributo(
                          atributo,
                          finalidade,
                          this.dadosCadastrais
                        );
                        this.disclaimerdadosCadastrais =
                          this.disclaimerdadosCadastrais || atributo.disclaimer
                            ? true
                            : false;
                      });
                    });

                    break;
                  }
                  case DescriptionBlocks.DADOSLOCALIZACAO: {
                    this.MostrarLocalizacao = true;
                    blocos.attributes.forEach((atributo) => {
                      atributo.purposes.forEach((finalidade) => {
                        this.tratarAtributo(
                          atributo,
                          finalidade,
                          this.dadosLocalizacao
                        );
                        this.disclaimerdadosLocalizacao =
                          this.disclaimerdadosLocalizacao || atributo.disclaimer
                            ? true
                            : false;
                      });
                    });

                    break;
                  }
                  case DescriptionBlocks.OUTROSDADOSCADASTRAIS: {
                    this.MostrarOutrosCadastrais = true;
                    blocos.attributes.forEach((atributo) => {
                      atributo.purposes.forEach((finalidade) => {
                        this.tratarAtributo(
                          atributo,
                          finalidade,
                          this.dadosOutrosCadastrais
                        );
                        this.disclaimerdadosOutrosCadastrais =
                          this.disclaimerdadosOutrosCadastrais ||
                          atributo.disclaimer
                            ? true
                            : false;
                      });
                    });

                    break;
                  }
                  case DescriptionBlocks.PARTICIPACAOSOCIETARIA: {
                    this.MostrarPartiSocietaria = true;
                    blocos.partnerParticipations.forEach((partisocietaria) => {
                      this.replacePurpose(partisocietaria.purposes);
                      this.tratarParticipacaoSocietaria(
                        partisocietaria,
                        partisocietaria.purposes,
                        this.dadosParticipacaoSoc
                      );
                      this.disclaimerdadosParticipacaoSoc =
                        this.disclaimerdadosParticipacaoSoc ||
                        partisocietaria.disclaimer
                          ? true
                          : false;
                    });

                    break;
                  }
                  case DescriptionBlocks.DADOSCONSULTACREDITO: {
                    this.MostrarConsultaCredito = true;
                    blocos.passages.forEach((passagem) => {
                      this.replacePurpose(passagem.purposes);
                      this.tratarPassagem(
                        passagem,
                        passagem.purposes,
                        passagem.origin,
                        this.dadosConsultaCredito
                      );
                    });

                    break;
                  }
                  case DescriptionBlocks.DADOSCONSULTALOCKUNLOCK: {
                    this.MostrarConsultaLockUnlock = true;
                    blocos.passages.forEach((passagem) => {
                      this.replacePurpose(passagem.purposes);
                      this.tratarPassagem(
                        passagem,
                        passagem.purposes,
                        passagem.origin,
                        this.dadosConsultaLockUnlock
                      );
                      this.disclaimerdadosConsultaLockUnlock = true;
                    });

                    break;
                  }
                  case DescriptionBlocks.DADOSCONSULTACERTIFICADO: {
                    this.MostrarConsultaCertificado = true;
                    blocos.attributes.forEach((atributo) => {
                      atributo.purposes.forEach((finalidade) => {
                        this.tratarAtributo(
                          atributo,
                          finalidade,
                          this.dadosConsultaCertificado
                        );
                        this.disclaimerdadosConsultaCertificado =
                          this.disclaimerdadosConsultaCertificado ||
                          atributo.disclaimer
                            ? true
                            : false;
                      });
                    });

                    break;
                  }
                  case DescriptionBlocks.DADOSDOCUMENTOSEXTRAVIADOS: {
                    this.MostrarDocumentosExtraviados = true;
                    blocos.attributes.forEach((atributo) => {
                      atributo.purposes.forEach((finalidade) => {
                        this.tratarAtributo(
                          atributo,
                          finalidade,
                          this.dadosDocumentosExtraviados
                        );
                      });
                    });

                    break;
                  }
                  case DescriptionBlocks.DADOSSCR: {
                    this.MostrarScr = true;
                    blocos.attributes.forEach((atributo) => {
                      this.replacePurpose(atributo.purposes);
                      atributo.purposes.forEach((finalidade) => {
                        this.tratarAtributoScr(
                          atributo,
                          finalidade,
                          this.dadosScr
                        );
                      });
                      this.disclaimerdadosConsultaScr =
                        this.disclaimerdadosConsultaScr || atributo.disclaimer
                          ? true
                          : false;
                    });

                    break;
                  }
                }
              });
            }
          },
          (err) => {
            if (
              err.error[0].message
                .toLocaleUpperCase()
                .indexOf('PEDIDO NAO ENCONTRADO') >= 0 ||
              err.message
                .toString()
                .toLocaleUpperCase()
                .indexOf('404 NOT FOUND') >= 0
            ) {
              this.showAlertMessage(AlertType.NO_INFO_FOUND);
              this.falha = false;
            } else {
              if (
                err.message
                  .toString()
                  .toLocaleUpperCase()
                  .indexOf('500 SERVER') >= 0
              ) {
                this.menssagemErro =
                  'Não foi possível processar sua requisição, por favor tente mais tarde!';
              } else {
                this.menssagemErro = err.message.toString();
              }
              this.showAlertMessage(AlertType.ERROR);
              this.falha = true;
            }
          }
        );
    } else {
      this.menssagemAtencao =
        'A solicitação ' +
        this.protocolo +
        ', criada em ' +
        formatDate(this.datacriacaoprotocolo, 'shortDate', 'pt') +
        ' está sendo processada.';
      this.showAlertMessage(AlertType.INFO);
    }
  }

  public ordenarPorOrigem(bloco: any) {
    return bloco.sort((a, b) => (a.origin > b.origin ? 1 : -1));
  }

  public tratarAtributo(atributo, finalidade, bloco) {
    try {
      this.checkDisclaimersToShow(finalidade);
      finalidade = this.replacePurpose(finalidade);
      atributo.alias = atributo.alias == null ? '' : atributo.alias;
      const informacaoformatada = this.formatarAtributo(
        atributo.value,
        atributo.description
      );

      //adiciona apenas se o valor, apos formatado, tiver conteudo
      if (
        !this.hasOnlySpecialCharater(informacaoformatada.trim()) &&
        informacaoformatada.trim().length > 0
      ) {
        //se bloco vazio ou atributo não está na lista, adiciona
        //se não acha o atributo e a informação na lista, adicina
        if (
          bloco.length <= 0 ||
          !bloco.find(
            (dados) =>
              dados.atributo.toString().toUpperCase().trim() ===
              atributo.alias.toString().toUpperCase().trim()
          ) ||
          !bloco.find(
            (dados) =>
              dados.atributo.toString().toUpperCase().trim() ===
                atributo.alias.toString().toUpperCase().trim() &&
              dados.informacao.toString().toUpperCase().trim() ===
                informacaoformatada.toString().toUpperCase().trim()
          )
        ) {
          bloco.push(
            this.createBlocoDados(
              atributo.alias,
              informacaoformatada,
              finalidade,
              this.toCamelCase(atributo.origin),
              atributo.disclaimer
            )
          );

          // se achar o atributo, informação, origem mas não a finalidade, concatena a finalidade
        } else if (
          bloco.find(
            (dados) =>
              dados.atributo.toString().toUpperCase().trim() ===
                atributo.alias.toString().toUpperCase().trim() &&
              dados.informacao.toString().toUpperCase().trim() ===
                informacaoformatada.toString().toUpperCase().trim() &&
              dados.origem.toString().toUpperCase().trim() ===
                atributo.origin.toString().toUpperCase().trim() &&
              dados.finalidade.indexOf(finalidade) < 0
          )
        ) {
          bloco.find(
            (dados) =>
              dados.atributo.toString().toUpperCase().trim() ===
                atributo.alias.toString().toUpperCase().trim() &&
              dados.informacao.toString().toUpperCase().trim() ===
                informacaoformatada.toString().toUpperCase().trim() &&
              dados.origem.toString().toUpperCase().trim() ===
                atributo.origin.toString().toUpperCase().trim()
          ).finalidade += ', ' + finalidade;

          //se não achar atributo, informação, origem e finalidade, adiciona
        } else if (
          !bloco.find(
            (dados) =>
              dados.atributo.toString().toUpperCase().trim() ===
                atributo.alias.toString().toUpperCase().trim() &&
              dados.informacao.toString().toUpperCase().trim() ===
                informacaoformatada.toString().toUpperCase().trim() &&
              dados.origem.toString().toUpperCase().trim() ===
                atributo.origin.toString().toUpperCase().trim() &&
              dados.finalidade.indexOf(finalidade) >= 0
          )
        ) {
          bloco.push(
            this.createBlocoDados(
              atributo.alias,
              informacaoformatada,
              finalidade,
              this.toCamelCase(atributo.origin),
              atributo.disclaimer
            )
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  public tratarPassagem(atributo, finalidade, origem, bloco) {
    try {
      if (origem) {
        const finalidadeFormatada = [];
        if (origem.toUpperCase() === 'SPC') {
          origem = origem.toUpperCase();
        } else {
          origem = this.toCamelCase(origem);
        }
        finalidade.forEach((purpose) => {
          finalidadeFormatada.push(this.replacePurpose(purpose));
        });
        bloco.push(
          this.createBlocoPassagem(
            atributo.empresa,
            atributo.cnpj,
            finalidadeFormatada.join(', '),
            origem,
            atributo.dtSearch,
            atributo.numSearches
          )
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  public tratarAtributoScr(atributo, finalidade, bloco) {
    try {
      this.checkDisclaimersToShow(finalidade);
      finalidade = this.replacePurpose(finalidade);
      atributo.alias = atributo.alias == null ? '' : atributo.alias;
      const informacaoformatada = this.formatarAtributo(
        atributo.value,
        atributo.description
      );

      //adiciona apenas se o valor, apos formatado, tiver conteudo
      if (
        !this.hasOnlySpecialCharater(informacaoformatada.trim()) &&
        informacaoformatada.trim().length > 0
      ) {
        //se bloco vazio ou atributo não está na lista, adiciona
        //se não acha o atributo e a informação na lista, adicina
        if (
          bloco.length <= 0 ||
          !bloco.find(
            (dados) =>
              dados.atributo.toString().toUpperCase().trim() ===
              atributo.alias.toString().toUpperCase().trim()
          ) ||
          !bloco.find(
            (dados) =>
              dados.atributo.toString().toUpperCase().trim() ===
                atributo.alias.toString().toUpperCase().trim() &&
              dados.informacao.toString().toUpperCase().trim() ===
                informacaoformatada.toString().toUpperCase().trim()
          )
        ) {
          bloco.push(
            this.createBlocoScr(
              atributo.alias,
              atributo.financialInstitution,
              atributo.contract,
              atributo.modality,
              atributo.referenceDate,
              informacaoformatada,
              finalidade,
              this.toCamelCase(atributo.origin),
              atributo.disclaimer
            )
          );

          // se achar o atributo, informação, origem mas não a finalidade, concatena a finalidade
        } else if (
          bloco.find(
            (dados) =>
              dados.atributo.toString().toUpperCase().trim() ===
                atributo.alias.toString().toUpperCase().trim() &&
              dados.informacao.toString().toUpperCase().trim() ===
                informacaoformatada.toString().toUpperCase().trim() &&
              dados.origem.toString().toUpperCase().trim() ===
                atributo.origin.toString().toUpperCase().trim() &&
              dados.finalidade.indexOf(finalidade) < 0
          )
        ) {
          bloco.find(
            (dados) =>
              dados.atributo.toString().toUpperCase().trim() ===
                atributo.alias.toString().toUpperCase().trim() &&
              dados.informacao.toString().toUpperCase().trim() ===
                informacaoformatada.toString().toUpperCase().trim() &&
              dados.origem.toString().toUpperCase().trim() ===
                atributo.origin.toString().toUpperCase().trim()
          ).finalidade += ', ' + finalidade;

          //se não achar atributo, informação, origem e finalidade, adiciona
        } else if (
          !bloco.find(
            (dados) =>
              dados.atributo.toString().toUpperCase().trim() ===
                atributo.alias.toString().toUpperCase().trim() &&
              dados.informacao.toString().toUpperCase().trim() ===
                informacaoformatada.toString().toUpperCase().trim() &&
              dados.origem.toString().toUpperCase().trim() ===
                atributo.origin.toString().toUpperCase().trim() &&
              dados.finalidade.indexOf(finalidade) >= 0
          )
        ) {
          bloco.push(
            this.createBlocoScr(
              atributo.alias,
              atributo.financialInstitution,
              atributo.contract,
              atributo.modality,
              atributo.referenceDate,
              informacaoformatada,
              finalidade,
              this.toCamelCase(atributo.origin),
              atributo.disclaimer
            )
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  public tratarParticipacaoSocietaria(atributo, finalidade, bloco) {
    try {
      let finalidadeFormatada = [];
      finalidade.forEach((purpose) => {
        finalidadeFormatada.push(this.replacePurpose(purpose));
      });

      bloco.push(
        this.createBlocoDados(
          'Empresa',
          atributo.business,
          finalidadeFormatada.join(', '),
          this.toCamelCase(atributo.origin),
          atributo.disclaimer
        )
      );
      bloco.push(
        this.createBlocoDados(
          'CNPJ',
          this.formatarAtributo(atributo.cnpj, 'CNPJ'),
          finalidadeFormatada.join(', '),
          this.toCamelCase(atributo.origin),
          atributo.disclaimer
        )
      );
      bloco.push(
        this.createBlocoDados(
          '% de participação',
          this.formatarAtributo(atributo.porcParticipation, 'PERCENT'),
          finalidadeFormatada.join(', '),
          this.toCamelCase(atributo.origin),
          atributo.disclaimer
        )
      );
      bloco.push(
        this.createBlocoDados(
          'Desde',
          this.formatarAtributo(atributo.since, 'DATE_PART_SOCIET'),
          finalidadeFormatada.join(', '),
          this.toCamelCase(atributo.origin),
          atributo.disclaimer
        )
      );
      bloco.push(
        this.createBlocoDados(
          'Última atualização',
          this.formatarAtributo(atributo.dtUpdated, 'DATE_PART_SOCIET'),
          finalidadeFormatada.join(', '),
          this.toCamelCase(atributo.origin),
          atributo.disclaimer
        )
      );
    } catch (error) {
      console.log(error);
    }
  }

  public formatarAtributo(valor, tipo): any {
    let valorformatado = valor == null ? '' : valor;
    valor = valorformatado;

    try {
      switch (tipo.toLocaleUpperCase()) {
        case 'BIRTHDATE':
        case 'DATANASC':
        case 'DATA': {
          valorformatado = formatDate(valorformatado, 'dd/MM/yyyy', 'pt');
          break;
        }
        case 'DATE_PART_SOCIET': {
          valorformatado = formatDate(new Date(valor), 'MMM/yyyy', 'pt');
          break;
        }
        case 'CPF': {
          valorformatado = valorformatado.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/g,
            '$1.$2.$3-$4'
          );
          break;
        }
        case 'CNPJ': {
          valorformatado = valorformatado.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
            '$1.$2.$3/$4-$5'
          );
          break;
        }
        case 'TELEFONE': {
          valorformatado = this.formatarTelefone(valorformatado);
          break;
        }
        case 'CONJUGE': {
          const conjuge: any = <any>(
            JSON.parse(valorformatado.replace(/'/g, '"'))
          );
          if (conjuge !== null) {
            valorformatado = ''.concat(
              'CPF: ',
              conjuge.cpf === null
                ? ''
                : conjuge.cpf.replace(
                    /(\d{3})(\d{3})(\d{3})(\d{2})/g,
                    '$1.$2.$3-$4'
                  ),
              ' \nNome: ',
              this.toCamelCase(conjuge.nome)
            );
          }
          break;
        }
        case 'EMPRESAQUETRABALHA':
        case 'EMPRESATRABALHA': {
          const empresa: any = JSON.parse(valorformatado.replace(/'/g, '"'));
          if (empresa !== null) {
            valorformatado = ''.concat(
              'CNPJ: ',
              empresa.cnpj === null
                ? ''
                : empresa.cnpj.replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                    '$1.$2.$3/$4-$5'
                  ),
              ' \nNome: ',
              empresa.nome === null ? '' : this.toCamelCase(empresa.nome)
            );
          }
          break;
        }
        case 'ENDERECO':
        case 'LOGRADOURO': {
          const endereco: any = JSON.parse(valorformatado.replace(/'/g, '"'));
          valorformatado = this.formatarEndereco(endereco);
          valorformatado = valorformatado.replace(/\s+/g, ' ');
          break;
        }
        case 'PARTISOCIETARIA': {
          const participacaosocietaria: any = JSON.parse(
            valorformatado.replace(/'/g, '"')
          );
          if (participacaosocietaria !== null) {
            valorformatado = ''.concat(
              participacaosocietaria.empresa === null
                ? ''
                : 'Empresa: ' +
                    this.toCamelCase(participacaosocietaria.empresa),
              participacaosocietaria.cnpj === null
                ? ''
                : '\nCNPJ: ' +
                    participacaosocietaria.cnpj.replace(
                      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                      '$1.$2.$3/$4-$5'
                    ),
              participacaosocietaria.data === null
                ? ''
                : '\nData: ' + participacaosocietaria.data,
              participacaosocietaria.modalidade === null
                ? ''
                : '\nModalidade: ' +
                    this.toCamelCase(participacaosocietaria.modalidade)
            );
          }
          break;
        }
        case 'PERCENT': {
          if (valor !== 'Não Informado') {
            let percent: number = parseInt(valor) || 0;
            valorformatado = percent + '%';
          }
          break;
        }
        case 'REFERENCIABANCARIA': {
          const referenciabancaria: any = JSON.parse(
            valorformatado.replace(/'/g, '"')
          );
          if (referenciabancaria !== null && referenciabancaria !== undefined) {
            valorformatado = ''.concat(
              referenciabancaria.nomeBanco === null
                ? ''
                : 'Banco: ' + this.toCamelCase(referenciabancaria.nomeBanco),
              referenciabancaria.agencia === null
                ? ''
                : '\nAgência: ' + referenciabancaria.agencia,
              referenciabancaria.conta === null
                ? ''
                : '\nConta: ' + referenciabancaria.conta
            );
          }
          break;
        }
        case 'CARTAOCREDITO': {
          const referenciacartaocredito: any = JSON.parse(
            valorformatado.replace(/'/g, '"')
          );
          if (
            referenciacartaocredito !== null &&
            referenciacartaocredito !== undefined
          ) {
            valorformatado = ''.concat(
              referenciacartaocredito.nomeBanco === null
                ? ''
                : 'Banco: ' +
                    this.toCamelCase(referenciacartaocredito.nomeBanco),
              referenciacartaocredito.bandeira === null
                ? ''
                : '\nBandeira: ' +
                    this.toCamelCase(referenciacartaocredito.bandeira),
              referenciacartaocredito.emissorCartao === null
                ? ''
                : '\nEmissor Cartão: ' +
                    this.toCamelCase(referenciacartaocredito.emissorCartao)
            );
          }
          break;
        }
        case 'OUTROSDOCUMENTOS':
        case 'RG': {
          try {
            const documento: any = JSON.parse(
              valorformatado.replace(/'/g, '"')
            );
            if (documento !== null) {
              valorformatado = ''.concat(
                'Documento: ',
                documento.documento === null ? '' : documento.documento,
                documento.orgaoExpedidor === null
                  ? ''
                  : ' - Orgão expedidor:' +
                      documento.orgaoExpedidor.toString().toUpperCase(),
                documento.ufExpedicao === null
                  ? ''
                  : ' - UF:' + documento.ufExpedicao.toString().toUpperCase(),
                documento.dataExpedicao === null ||
                  documento.dataExpedicao === undefined
                  ? ''
                  : ' - Data de expedição: ' +
                      formatDate(documento.dataExpedicao, 'dd/MM/yyyy', 'pt')
              );
            }
          } catch (error) {
            valorformatado = '';
          }
          break;
        }
        case 'EMAIL':
        case 'E-MAIL': {
          valorformatado = valorformatado.toString().toLowerCase();
          break;
        }
        default: {
          valorformatado = this.toCamelCase(valorformatado);
          break;
        }
      }
    } catch (error) {
      valorformatado = valor;
    }
    return valorformatado;
  }

  public toCamelCase(strCC): string {
    var result = '';
    if (typeof strCC === 'undefined' || strCC == null) {
      return result;
    }

    strCC = strCC.charAt(0).toUpperCase() + strCC.substring(1).toLowerCase();
    var words = strCC.split(' ');
    for (var i = 0; i < words.length; ++i) {
      result +=
        (i > 0 ? ' ' : '') +
        words[i].substring(0, 1).toUpperCase() +
        words[i].substring(1);
    }
    return result;
  }

  public formatarTelefone(telefone: any): string {
    const tel: any = <any>JSON.parse(telefone.trim().replace(/'/g, '"'));
    if (tel !== null) {
      if (tel.telefone != undefined) {
        tel.telefone = tel.telefone.replace(/^0/, ' ');
        tel.ddd = tel.ddd.replace(/^00/, '').replace(/^0/, '');
        tel.ddd = '00'
          .concat(tel.ddd)
          .substring(tel.ddd.length, tel.ddd.length + 2);
      }
    }
    let vFone = tel.ddd.concat(tel.telefone);
    vFone = vFone.replace(/\D/g, '');
    if (vFone.length > 10) {
      vFone = vFone.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
    } else if (vFone.length > 8) {
      vFone = vFone.replace(/^(\d\d)(\d{4})(\d{4}).*/, '($1) $2-$3');
    } else if (vFone.length > 5) {
      vFone = vFone.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2-$3');
    } else {
      vFone = vFone.replace(/^(\d*)/, '($1)');
    }
    return vFone;
  }

  public formatarEndereco(endereco: any): string {
    return ''.concat(
      endereco.endereco === null
        ? ''
        : this.toCamelCase(
            endereco.endereco.toString().trim().replace('  ', '')
          ),
      endereco.bairro === null || endereco.bairro.toString().trim().length <= 0
        ? ''
        : ' - ' + this.toCamelCase(endereco.bairro.toString().trim()),
      endereco.cep === null || endereco.cep.toString().trim().length <= 0
        ? ''
        : ' - ' + endereco.cep.toString().trim(),
      endereco.municipio === null ||
        endereco.municipio.toString().trim().length <= 0
        ? ''
        : ' - ' + this.toCamelCase(endereco.municipio.toString().trim()),
      endereco.uf === null || endereco.uf.toString().trim().length <= 0
        ? ''
        : ' - ' + endereco.uf.toString().trim().toUpperCase()
    );
  }

  public hasOnlySpecialCharater(val) {
    var pattern = /^[^a-zA-Z0-9]+$/;
    return pattern.test(val);
  }

  checarLarguraTela(): boolean {
    return window.screen.width > 768;
  }

  checkDisclaimersToShow(purpose) {
    this.disclaimerMarketing =
      this.disclaimerMarketing ||
      purpose.toLocaleUpperCase() === DescriptionTypes.MARKETING.toString();
    this.disclaimerCredito =
      this.disclaimerCredito ||
      purpose.toLocaleUpperCase() === DescriptionTypes.CREDITO.toString();
    this.disclaimerFraude =
      this.disclaimerFraude ||
      purpose.toLocaleUpperCase() === DescriptionTypes.FRAUDE.toString();
    this.disclaimerDataQuality =
      this.disclaimerDataQuality ||
      purpose.toLocaleUpperCase() === DescriptionTypes.DATA_QUALITY.toString();
    this.disclaimerCertificado =
      this.disclaimerCertificado ||
      purpose.toLocaleUpperCase() ===
        DescriptionTypes.CERTIFICADO_DIGITAL.toString();
    this.disclaimerScr =
      this.disclaimerScr ||
      purpose.toLocaleUpperCase() === DescriptionTypes.SCR.toString();
  }

  replacePurpose(purpose) {
    switch (purpose.toString().toUpperCase()) {
      case DescriptionTypes.MARKETING.toString(): {
        return 'Direcionamento de Ofertas';
      }
      case DescriptionTypes.CREDITO.toString(): {
        return 'Proteção ao Crédito';
      }
      case DescriptionTypes.FRAUDE.toString(): {
        return 'Prevenção à Fraude';
      }
      case DescriptionTypes.DATA_QUALITY.toString(): {
        return 'Qualidade de Dados';
      }
      case DescriptionTypes.CERTIFICADO_DIGITAL.toString(): {
        return 'Certificado Digital';
      }
      case DescriptionTypes.SCR.toString(): {
        return 'Proteção ao Crédito';
      }

      default: {
        return purpose;
      }
    }
  }

  exportToPdf() {
    const reqPdf = {
      orderId: this.numpedido,
      origin: 22,
      middle: 36,
    };
    this.relatorioAnaliticoService.baixarPdf(reqPdf).subscribe(
      (res) => {
        this.urlPdf = window.URL.createObjectURL(res);
        window.open(this.urlPdf);
      },
      (err) => {
        this.abrirModalErroPdf = true;
        this.modalErro.open();
      }
    );
  }

  private prepareModality(modality: string) {
    switch (modality.substring(0, 2)) {
      case '01':
        return 'Adiantamentos a depositantes';
      case '02':
        return 'Empréstimos';
      case '03':
        return 'Direitos creditórios descontados';
      case '04':
        return 'Financiamentos';
      case '05':
        return 'Financiamentos a exportação';
      case '06':
        return 'Financiamentos a importação';
      case '07':
        return 'Financiamentos com interveniência';
      case '08':
        return 'Financiamentos rurais';
      case '09':
        return 'Financiamentos imobiliários';
      case '10':
        return 'Financiamentos de titulos e valores mobiliários';
      case '11':
        return 'Financiamentos de infraestrutura e desenvolvimento';
      case '12':
        return 'Operações de arrendamento';
      case '13':
        return 'Outros créditos';
      default:
        return '';
    }
  }
}
